import type { ApiComputedMeasurement, MeasurementsResponse, ProviderSyncStatus } from "@/lib/api/types";
import type { ProfileData } from "@/lib/core/interfaces";

// Demo profile data
export const demoProfile: ProfileData = {
  firstName: "Sample User",
  goalStart: "2024-01-01", // Will be adjusted at runtime
  goalWeight: 195, // Goal weight in lbs (user's units)
  plannedPoundsPerWeek: -1,
  dayStartOffset: 3, // 3 AM
  useMetric: false,
  showCalories: true,
  sharingToken: undefined,
};

const preComputedDemoMeasurements: ApiComputedMeasurement[] = [
  {
    date: "2011-03-23",
    actualWeight: 99.473,
    trendWeight: 99.473,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3382,
    trendFatPercent: 0.3382,
    trendFatMass: 33.642,
    trendLeanMass: 65.831,
  },
  {
    date: "2011-03-24",
    actualWeight: 98.929,
    trendWeight: 99.418,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3365,
    trendFatPercent: 0.338,
    trendFatMass: 33.607,
    trendLeanMass: 65.812,
  },
  {
    date: "2011-03-25",
    actualWeight: 98.747,
    trendWeight: 99.351,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3351,
    trendFatPercent: 0.3377,
    trendFatMass: 33.555,
    trendLeanMass: 65.797,
  },
  {
    date: "2011-03-26",
    actualWeight: 99.065,
    trendWeight: 99.323,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3312,
    trendFatPercent: 0.3371,
    trendFatMass: 33.48,
    trendLeanMass: 65.842,
  },
  {
    date: "2011-03-27",
    actualWeight: 98.747,
    trendWeight: 99.265,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3273,
    trendFatPercent: 0.3361,
    trendFatMass: 33.364,
    trendLeanMass: 65.901,
  },
  {
    date: "2011-03-28",
    actualWeight: 98.294,
    trendWeight: 99.168,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3325,
    trendFatPercent: 0.3357,
    trendFatMass: 33.296,
    trendLeanMass: 65.872,
  },
  {
    date: "2011-03-29",
    actualWeight: 98.475,
    trendWeight: 99.099,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3228,
    trendFatPercent: 0.3345,
    trendFatMass: 33.145,
    trendLeanMass: 65.953,
  },
  {
    date: "2011-03-30",
    actualWeight: 98.203,
    trendWeight: 99.009,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3155,
    trendFatPercent: 0.3326,
    trendFatMass: 32.929,
    trendLeanMass: 66.08,
  },
  {
    date: "2011-03-31",
    actualWeight: 98.248,
    trendWeight: 98.933,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3307,
    trendFatPercent: 0.3324,
    trendFatMass: 32.885,
    trendLeanMass: 66.048,
  },
  {
    date: "2011-04-01",
    actualWeight: 97.749,
    trendWeight: 98.815,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3154,
    trendFatPercent: 0.3307,
    trendFatMass: 32.68,
    trendLeanMass: 66.135,
  },
  {
    date: "2011-04-02",
    actualWeight: 98.021,
    trendWeight: 98.735,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3196,
    trendFatPercent: 0.3296,
    trendFatMass: 32.545,
    trendLeanMass: 66.191,
  },
  {
    date: "2011-04-03",
    actualWeight: 97.704,
    trendWeight: 98.632,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3188,
    trendFatPercent: 0.3285,
    trendFatMass: 32.405,
    trendLeanMass: 66.227,
  },
  {
    date: "2011-04-04",
    actualWeight: 97.931,
    trendWeight: 98.562,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3165,
    trendFatPercent: 0.3273,
    trendFatMass: 32.264,
    trendLeanMass: 66.298,
  },
  {
    date: "2011-04-05",
    actualWeight: 97.25,
    trendWeight: 98.431,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3147,
    trendFatPercent: 0.326,
    trendFatMass: 32.098,
    trendLeanMass: 66.333,
  },
  {
    date: "2011-04-06",
    actualWeight: 96.978,
    trendWeight: 98.285,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3137,
    trendFatPercent: 0.3248,
    trendFatMass: 31.93,
    trendLeanMass: 66.355,
  },
  {
    date: "2011-04-07",
    actualWeight: 96.933,
    trendWeight: 98.15,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3162,
    trendFatPercent: 0.3239,
    trendFatMass: 31.802,
    trendLeanMass: 66.348,
  },
  {
    date: "2011-04-08",
    actualWeight: 96.661,
    trendWeight: 98.001,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3145,
    trendFatPercent: 0.323,
    trendFatMass: 31.662,
    trendLeanMass: 66.339,
  },
  {
    date: "2011-04-09",
    actualWeight: 96.57,
    trendWeight: 97.858,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3116,
    trendFatPercent: 0.3219,
    trendFatMass: 31.505,
    trendLeanMass: 66.353,
  },
  {
    date: "2011-04-10",
    actualWeight: 96.388,
    trendWeight: 97.711,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3049,
    trendFatPercent: 0.3202,
    trendFatMass: 31.293,
    trendLeanMass: 66.418,
  },
  {
    date: "2011-04-11",
    actualWeight: 96.162,
    trendWeight: 97.556,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3132,
    trendFatPercent: 0.3195,
    trendFatMass: 31.176,
    trendLeanMass: 66.38,
  },
  {
    date: "2011-04-12",
    actualWeight: 96.434,
    trendWeight: 97.444,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3174,
    trendFatPercent: 0.3193,
    trendFatMass: 31.119,
    trendLeanMass: 66.325,
  },
  {
    date: "2011-04-13",
    actualWeight: 96.298,
    trendWeight: 97.329,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3143,
    trendFatPercent: 0.3188,
    trendFatMass: 31.034,
    trendLeanMass: 66.296,
  },
  {
    date: "2011-04-14",
    actualWeight: 96.525,
    trendWeight: 97.249,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3143,
    trendFatPercent: 0.3183,
    trendFatMass: 30.964,
    trendLeanMass: 66.285,
  },
  {
    date: "2011-04-15",
    actualWeight: 96.525,
    trendWeight: 97.176,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3099,
    trendFatPercent: 0.3175,
    trendFatMass: 30.859,
    trendLeanMass: 66.318,
  },
  {
    date: "2011-04-16",
    actualWeight: 96.751,
    trendWeight: 97.134,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3166,
    trendFatPercent: 0.3174,
    trendFatMass: 30.836,
    trendLeanMass: 66.298,
  },
  {
    date: "2011-04-17",
    actualWeight: 95.708,
    trendWeight: 96.991,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3075,
    trendFatPercent: 0.3164,
    trendFatMass: 30.696,
    trendLeanMass: 66.296,
  },
  {
    date: "2011-04-18",
    actualWeight: 95.663,
    trendWeight: 96.858,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3087,
    trendFatPercent: 0.3156,
    trendFatMass: 30.579,
    trendLeanMass: 66.279,
  },
  {
    date: "2011-04-19",
    actualWeight: 95.89,
    trendWeight: 96.761,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3096,
    trendFatPercent: 0.315,
    trendFatMass: 30.49,
    trendLeanMass: 66.272,
  },
  {
    date: "2011-04-20",
    actualWeight: 95.731,
    trendWeight: 96.658,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3077,
    trendFatPercent: 0.3143,
    trendFatMass: 30.387,
    trendLeanMass: 66.272,
  },
  {
    date: "2011-04-21",
    actualWeight: 95.572,
    trendWeight: 96.55,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3059,
    trendFatPercent: 0.3135,
    trendFatMass: 30.272,
    trendLeanMass: 66.278,
  },
  {
    date: "2011-04-22",
    actualWeight: 95.481,
    trendWeight: 96.443,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3087,
    trendFatPercent: 0.313,
    trendFatMass: 30.192,
    trendLeanMass: 66.251,
  },
  {
    date: "2011-04-23",
    actualWeight: 95.391,
    trendWeight: 96.338,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3115,
    trendFatPercent: 0.3128,
    trendFatMass: 30.144,
    trendLeanMass: 66.194,
  },
  {
    date: "2011-04-24",
    actualWeight: 95.402,
    trendWeight: 96.244,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3104,
    trendFatPercent: 0.3126,
    trendFatMass: 30.091,
    trendLeanMass: 66.153,
  },
  {
    date: "2011-04-25",
    actualWeight: 95.413,
    trendWeight: 96.161,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3093,
    trendFatPercent: 0.3123,
    trendFatMass: 30.033,
    trendLeanMass: 66.128,
  },
  {
    date: "2011-04-26",
    actualWeight: 95.425,
    trendWeight: 96.087,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3082,
    trendFatPercent: 0.3119,
    trendFatMass: 29.971,
    trendLeanMass: 66.117,
  },
  {
    date: "2011-04-27",
    actualWeight: 95.436,
    trendWeight: 96.022,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3071,
    trendFatPercent: 0.3114,
    trendFatMass: 29.905,
    trendLeanMass: 66.118,
  },
  {
    date: "2011-04-28",
    actualWeight: 94.982,
    trendWeight: 95.918,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3031,
    trendFatPercent: 0.3106,
    trendFatMass: 29.793,
    trendLeanMass: 66.125,
  },
  {
    date: "2011-04-29",
    actualWeight: 95.481,
    trendWeight: 95.875,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3053,
    trendFatPercent: 0.31,
    trendFatMass: 29.729,
    trendLeanMass: 66.146,
  },
  {
    date: "2011-04-30",
    actualWeight: 95.3,
    trendWeight: 95.817,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2999,
    trendFatPercent: 0.309,
    trendFatMass: 29.614,
    trendLeanMass: 66.203,
  },
  {
    date: "2011-05-01",
    actualWeight: 94.756,
    trendWeight: 95.711,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2969,
    trendFatPercent: 0.3078,
    trendFatMass: 29.466,
    trendLeanMass: 66.245,
  },
  {
    date: "2011-05-02",
    actualWeight: 94.937,
    trendWeight: 95.634,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3032,
    trendFatPercent: 0.3073,
    trendFatMass: 29.398,
    trendLeanMass: 66.236,
  },
  {
    date: "2011-05-03",
    actualWeight: 95.3,
    trendWeight: 95.6,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3101,
    trendFatPercent: 0.3076,
    trendFatMass: 29.413,
    trendLeanMass: 66.187,
  },
  {
    date: "2011-05-04",
    actualWeight: 95.028,
    trendWeight: 95.543,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3001,
    trendFatPercent: 0.3069,
    trendFatMass: 29.324,
    trendLeanMass: 66.219,
  },
  {
    date: "2011-05-05",
    actualWeight: 95.118,
    trendWeight: 95.5,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3128,
    trendFatPercent: 0.3075,
    trendFatMass: 29.367,
    trendLeanMass: 66.134,
  },
  {
    date: "2011-05-06",
    actualWeight: 94.937,
    trendWeight: 95.444,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3079,
    trendFatPercent: 0.3075,
    trendFatMass: 29.353,
    trendLeanMass: 66.091,
  },
  {
    date: "2011-05-07",
    actualWeight: 94.574,
    trendWeight: 95.357,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3049,
    trendFatPercent: 0.3072,
    trendFatMass: 29.301,
    trendLeanMass: 66.056,
  },
  {
    date: "2011-05-08",
    actualWeight: 94.665,
    trendWeight: 95.288,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3057,
    trendFatPercent: 0.3071,
    trendFatMass: 29.265,
    trendLeanMass: 66.023,
  },
  {
    date: "2011-05-09",
    actualWeight: 94.756,
    trendWeight: 95.235,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3065,
    trendFatPercent: 0.307,
    trendFatMass: 29.243,
    trendLeanMass: 65.992,
  },
  {
    date: "2011-05-10",
    actualWeight: 94.846,
    trendWeight: 95.196,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3072,
    trendFatPercent: 0.307,
    trendFatMass: 29.232,
    trendLeanMass: 65.964,
  },
  {
    date: "2011-05-11",
    actualWeight: 94.937,
    trendWeight: 95.17,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.308,
    trendFatPercent: 0.3071,
    trendFatMass: 29.233,
    trendLeanMass: 65.937,
  },
  {
    date: "2011-05-12",
    actualWeight: 95.209,
    trendWeight: 95.174,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3067,
    trendFatPercent: 0.3071,
    trendFatMass: 29.23,
    trendLeanMass: 65.944,
  },
  {
    date: "2011-05-13",
    actualWeight: 95.148,
    trendWeight: 95.172,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.306,
    trendFatPercent: 0.307,
    trendFatMass: 29.218,
    trendLeanMass: 65.953,
  },
  {
    date: "2011-05-14",
    actualWeight: 95.088,
    trendWeight: 95.163,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3052,
    trendFatPercent: 0.3068,
    trendFatMass: 29.199,
    trendLeanMass: 65.964,
  },
  {
    date: "2011-05-15",
    actualWeight: 95.028,
    trendWeight: 95.149,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3045,
    trendFatPercent: 0.3066,
    trendFatMass: 29.172,
    trendLeanMass: 65.977,
  },
  {
    date: "2011-05-16",
    actualWeight: 95.073,
    trendWeight: 95.142,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3048,
    trendFatPercent: 0.3064,
    trendFatMass: 29.153,
    trendLeanMass: 65.989,
  },
  {
    date: "2011-05-17",
    actualWeight: 94.665,
    trendWeight: 95.094,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3015,
    trendFatPercent: 0.3059,
    trendFatMass: 29.092,
    trendLeanMass: 66.002,
  },
  {
    date: "2011-05-18",
    actualWeight: 94.778,
    trendWeight: 95.063,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3051,
    trendFatPercent: 0.3058,
    trendFatMass: 29.074,
    trendLeanMass: 65.988,
  },
  {
    date: "2011-05-19",
    actualWeight: 94.892,
    trendWeight: 95.045,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3086,
    trendFatPercent: 0.3061,
    trendFatMass: 29.095,
    trendLeanMass: 65.95,
  },
  {
    date: "2011-05-20",
    actualWeight: 94.982,
    trendWeight: 95.039,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2999,
    trendFatPercent: 0.3055,
    trendFatMass: 29.034,
    trendLeanMass: 66.005,
  },
  {
    date: "2011-05-21",
    actualWeight: 95.073,
    trendWeight: 95.043,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2912,
    trendFatPercent: 0.3041,
    trendFatMass: 28.899,
    trendLeanMass: 66.143,
  },
  {
    date: "2011-05-22",
    actualWeight: 95.012,
    trendWeight: 95.04,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2944,
    trendFatPercent: 0.3031,
    trendFatMass: 28.807,
    trendLeanMass: 66.233,
  },
  {
    date: "2011-05-23",
    actualWeight: 94.952,
    trendWeight: 95.031,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2976,
    trendFatPercent: 0.3025,
    trendFatMass: 28.752,
    trendLeanMass: 66.279,
  },
  {
    date: "2011-05-24",
    actualWeight: 94.892,
    trendWeight: 95.017,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3008,
    trendFatPercent: 0.3024,
    trendFatMass: 28.731,
    trendLeanMass: 66.286,
  },
  {
    date: "2011-05-25",
    actualWeight: 95.3,
    trendWeight: 95.045,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3182,
    trendFatPercent: 0.3039,
    trendFatMass: 28.89,
    trendLeanMass: 66.155,
  },
  {
    date: "2011-05-26",
    actualWeight: 95.3,
    trendWeight: 95.071,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3068,
    trendFatPercent: 0.3042,
    trendFatMass: 28.925,
    trendLeanMass: 66.146,
  },
  {
    date: "2011-05-27",
    actualWeight: 94.982,
    trendWeight: 95.062,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3055,
    trendFatPercent: 0.3044,
    trendFatMass: 28.934,
    trendLeanMass: 66.128,
  },
  {
    date: "2011-05-28",
    actualWeight: 94.937,
    trendWeight: 95.049,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2983,
    trendFatPercent: 0.3038,
    trendFatMass: 28.873,
    trendLeanMass: 66.177,
  },
  {
    date: "2011-05-29",
    actualWeight: 94.876,
    trendWeight: 95.032,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.297,
    trendFatPercent: 0.3031,
    trendFatMass: 28.803,
    trendLeanMass: 66.229,
  },
  {
    date: "2011-05-30",
    actualWeight: 94.816,
    trendWeight: 95.01,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2958,
    trendFatPercent: 0.3024,
    trendFatMass: 28.728,
    trendLeanMass: 66.283,
  },
  {
    date: "2011-05-31",
    actualWeight: 94.756,
    trendWeight: 94.985,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2945,
    trendFatPercent: 0.3016,
    trendFatMass: 28.645,
    trendLeanMass: 66.34,
  },
  {
    date: "2011-06-01",
    actualWeight: 95.3,
    trendWeight: 95.016,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2944,
    trendFatPercent: 0.3008,
    trendFatMass: 28.587,
    trendLeanMass: 66.43,
  },
  {
    date: "2011-06-02",
    actualWeight: 95.028,
    trendWeight: 95.018,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3003,
    trendFatPercent: 0.3008,
    trendFatMass: 28.582,
    trendLeanMass: 66.436,
  },
  {
    date: "2011-06-03",
    actualWeight: 95.028,
    trendWeight: 95.019,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2977,
    trendFatPercent: 0.3005,
    trendFatMass: 28.552,
    trendLeanMass: 66.466,
  },
  {
    date: "2011-06-04",
    actualWeight: 94.892,
    trendWeight: 95.006,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2971,
    trendFatPercent: 0.3001,
    trendFatMass: 28.516,
    trendLeanMass: 66.49,
  },
  {
    date: "2011-06-05",
    actualWeight: 95.368,
    trendWeight: 95.042,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3031,
    trendFatPercent: 0.3004,
    trendFatMass: 28.555,
    trendLeanMass: 66.487,
  },
  {
    date: "2011-06-06",
    actualWeight: 95.844,
    trendWeight: 95.122,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3091,
    trendFatPercent: 0.3013,
    trendFatMass: 28.662,
    trendLeanMass: 66.46,
  },
  {
    date: "2011-06-07",
    actualWeight: 95.753,
    trendWeight: 95.186,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3081,
    trendFatPercent: 0.302,
    trendFatMass: 28.746,
    trendLeanMass: 66.439,
  },
  {
    date: "2011-06-08",
    actualWeight: 95.663,
    trendWeight: 95.233,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.307,
    trendFatPercent: 0.3025,
    trendFatMass: 28.808,
    trendLeanMass: 66.425,
  },
  {
    date: "2011-06-09",
    actualWeight: 95.527,
    trendWeight: 95.262,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3145,
    trendFatPercent: 0.3037,
    trendFatMass: 28.932,
    trendLeanMass: 66.331,
  },
  {
    date: "2011-06-10",
    actualWeight: 95.708,
    trendWeight: 95.307,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3137,
    trendFatPercent: 0.3047,
    trendFatMass: 29.041,
    trendLeanMass: 66.266,
  },
  {
    date: "2011-06-11",
    actualWeight: 95.89,
    trendWeight: 95.365,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3117,
    trendFatPercent: 0.3054,
    trendFatMass: 29.126,
    trendLeanMass: 66.239,
  },
  {
    date: "2011-06-12",
    actualWeight: 95.391,
    trendWeight: 95.368,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3053,
    trendFatPercent: 0.3054,
    trendFatMass: 29.126,
    trendLeanMass: 66.242,
  },
  {
    date: "2011-06-13",
    actualWeight: 94.892,
    trendWeight: 95.32,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2989,
    trendFatPercent: 0.3047,
    trendFatMass: 29.049,
    trendLeanMass: 66.271,
  },
  {
    date: "2011-06-14",
    actualWeight: 94.982,
    trendWeight: 95.286,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2986,
    trendFatPercent: 0.3041,
    trendFatMass: 28.981,
    trendLeanMass: 66.306,
  },
  {
    date: "2011-06-15",
    actualWeight: 94.619,
    trendWeight: 95.22,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3011,
    trendFatPercent: 0.3038,
    trendFatMass: 28.932,
    trendLeanMass: 66.288,
  },
  {
    date: "2011-06-16",
    actualWeight: 94.695,
    trendWeight: 95.167,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3031,
    trendFatPercent: 0.3037,
    trendFatMass: 28.909,
    trendLeanMass: 66.259,
  },
  {
    date: "2011-06-17",
    actualWeight: 94.771,
    trendWeight: 95.128,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.3052,
    trendFatPercent: 0.3039,
    trendFatMass: 28.91,
    trendLeanMass: 66.218,
  },
  {
    date: "2011-06-18",
    actualWeight: 94.846,
    trendWeight: 95.099,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3072,
    trendFatPercent: 0.3042,
    trendFatMass: 28.933,
    trendLeanMass: 66.167,
  },
  {
    date: "2011-06-19",
    actualWeight: 94.71,
    trendWeight: 95.06,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3009,
    trendFatPercent: 0.3039,
    trendFatMass: 28.889,
    trendLeanMass: 66.171,
  },
  {
    date: "2011-06-20",
    actualWeight: 95.028,
    trendWeight: 95.057,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2961,
    trendFatPercent: 0.3031,
    trendFatMass: 28.814,
    trendLeanMass: 66.243,
  },
  {
    date: "2011-06-21",
    actualWeight: 94.71,
    trendWeight: 95.022,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3019,
    trendFatPercent: 0.303,
    trendFatMass: 28.792,
    trendLeanMass: 66.231,
  },
  {
    date: "2011-06-22",
    actualWeight: 94.257,
    trendWeight: 94.946,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.303,
    trendFatPercent: 0.303,
    trendFatMass: 28.769,
    trendLeanMass: 66.177,
  },
  {
    date: "2011-06-23",
    actualWeight: 94.211,
    trendWeight: 94.873,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2999,
    trendFatPercent: 0.3027,
    trendFatMass: 28.717,
    trendLeanMass: 66.155,
  },
  {
    date: "2011-06-24",
    actualWeight: 94.574,
    trendWeight: 94.843,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.3008,
    trendFatPercent: 0.3025,
    trendFatMass: 28.69,
    trendLeanMass: 66.152,
  },
  {
    date: "2011-06-25",
    actualWeight: 94.347,
    trendWeight: 94.793,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2979,
    trendFatPercent: 0.302,
    trendFatMass: 28.632,
    trendLeanMass: 66.161,
  },
  {
    date: "2011-06-26",
    actualWeight: 94.166,
    trendWeight: 94.73,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2944,
    trendFatPercent: 0.3013,
    trendFatMass: 28.541,
    trendLeanMass: 66.189,
  },
  {
    date: "2011-06-27",
    actualWeight: 93.984,
    trendWeight: 94.656,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2909,
    trendFatPercent: 0.3002,
    trendFatMass: 28.421,
    trendLeanMass: 66.235,
  },
  {
    date: "2011-06-28",
    actualWeight: 93.803,
    trendWeight: 94.57,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2874,
    trendFatPercent: 0.2989,
    trendFatMass: 28.275,
    trendLeanMass: 66.296,
  },
  {
    date: "2011-06-29",
    actualWeight: 93.848,
    trendWeight: 94.498,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2947,
    trendFatPercent: 0.2985,
    trendFatMass: 28.213,
    trendLeanMass: 66.285,
  },
  {
    date: "2011-06-30",
    actualWeight: 93.78,
    trendWeight: 94.426,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2943,
    trendFatPercent: 0.2981,
    trendFatMass: 28.152,
    trendLeanMass: 66.275,
  },
  {
    date: "2011-07-01",
    actualWeight: 93.712,
    trendWeight: 94.355,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2939,
    trendFatPercent: 0.2977,
    trendFatMass: 28.091,
    trendLeanMass: 66.264,
  },
  {
    date: "2011-07-02",
    actualWeight: 93.758,
    trendWeight: 94.295,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2953,
    trendFatPercent: 0.2974,
    trendFatMass: 28.05,
    trendLeanMass: 66.245,
  },
  {
    date: "2011-07-03",
    actualWeight: 93.894,
    trendWeight: 94.255,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2921,
    trendFatPercent: 0.2969,
    trendFatMass: 27.988,
    trendLeanMass: 66.267,
  },
  {
    date: "2011-07-04",
    actualWeight: 93.622,
    trendWeight: 94.192,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2938,
    trendFatPercent: 0.2966,
    trendFatMass: 27.94,
    trendLeanMass: 66.252,
  },
  {
    date: "2011-07-05",
    actualWeight: 93.213,
    trendWeight: 94.094,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.297,
    trendFatPercent: 0.2966,
    trendFatMass: 27.914,
    trendLeanMass: 66.18,
  },
  {
    date: "2011-07-06",
    actualWeight: 93.939,
    trendWeight: 94.078,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2941,
    trendFatPercent: 0.2964,
    trendFatMass: 27.885,
    trendLeanMass: 66.193,
  },
  {
    date: "2011-07-07",
    actualWeight: 93.44,
    trendWeight: 94.014,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2969,
    trendFatPercent: 0.2964,
    trendFatMass: 27.871,
    trendLeanMass: 66.143,
  },
  {
    date: "2011-07-08",
    actualWeight: 93.349,
    trendWeight: 93.948,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2858,
    trendFatPercent: 0.2954,
    trendFatMass: 27.752,
    trendLeanMass: 66.196,
  },
  {
    date: "2011-07-09",
    actualWeight: 92.714,
    trendWeight: 93.825,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.294,
    trendFatPercent: 0.2952,
    trendFatMass: 27.703,
    trendLeanMass: 66.122,
  },
  {
    date: "2011-07-10",
    actualWeight: 93.44,
    trendWeight: 93.786,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2877,
    trendFatPercent: 0.2945,
    trendFatMass: 27.621,
    trendLeanMass: 66.166,
  },
  {
    date: "2011-07-11",
    actualWeight: 93.622,
    trendWeight: 93.77,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.288,
    trendFatPercent: 0.2938,
    trendFatMass: 27.555,
    trendLeanMass: 66.215,
  },
  {
    date: "2011-07-12",
    actualWeight: 93.576,
    trendWeight: 93.75,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2961,
    trendFatPercent: 0.2941,
    trendFatMass: 27.57,
    trendLeanMass: 66.18,
  },
  {
    date: "2011-07-13",
    actualWeight: 93.304,
    trendWeight: 93.706,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2887,
    trendFatPercent: 0.2935,
    trendFatMass: 27.507,
    trendLeanMass: 66.199,
  },
  {
    date: "2011-07-14",
    actualWeight: 93.622,
    trendWeight: 93.697,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2859,
    trendFatPercent: 0.2928,
    trendFatMass: 27.433,
    trendLeanMass: 66.265,
  },
  {
    date: "2011-07-15",
    actualWeight: 93.032,
    trendWeight: 93.631,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2818,
    trendFatPercent: 0.2917,
    trendFatMass: 27.311,
    trendLeanMass: 66.32,
  },
  {
    date: "2011-07-16",
    actualWeight: 93.44,
    trendWeight: 93.612,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2872,
    trendFatPercent: 0.2912,
    trendFatMass: 27.264,
    trendLeanMass: 66.348,
  },
  {
    date: "2011-07-17",
    actualWeight: 93.213,
    trendWeight: 93.572,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2956,
    trendFatPercent: 0.2917,
    trendFatMass: 27.293,
    trendLeanMass: 66.279,
  },
  {
    date: "2011-07-18",
    actualWeight: 92.941,
    trendWeight: 93.509,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2969,
    trendFatPercent: 0.2922,
    trendFatMass: 27.323,
    trendLeanMass: 66.186,
  },
  {
    date: "2011-07-19",
    actualWeight: 92.714,
    trendWeight: 93.429,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2989,
    trendFatPercent: 0.2929,
    trendFatMass: 27.362,
    trendLeanMass: 66.068,
  },
  {
    date: "2011-07-20",
    actualWeight: 92.714,
    trendWeight: 93.358,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2847,
    trendFatPercent: 0.292,
    trendFatMass: 27.265,
    trendLeanMass: 66.093,
  },
  {
    date: "2011-07-21",
    actualWeight: 92.578,
    trendWeight: 93.28,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2881,
    trendFatPercent: 0.2916,
    trendFatMass: 27.206,
    trendLeanMass: 66.074,
  },
  {
    date: "2011-07-22",
    actualWeight: 92.85,
    trendWeight: 93.237,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2917,
    trendFatPercent: 0.2916,
    trendFatMass: 27.194,
    trendLeanMass: 66.043,
  },
  {
    date: "2011-07-23",
    actualWeight: 92.261,
    trendWeight: 93.139,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2826,
    trendFatPercent: 0.2907,
    trendFatMass: 27.082,
    trendLeanMass: 66.058,
  },
  {
    date: "2011-07-24",
    actualWeight: 92.76,
    trendWeight: 93.101,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2834,
    trendFatPercent: 0.29,
    trendFatMass: 27.002,
    trendLeanMass: 66.099,
  },
  {
    date: "2011-07-25",
    actualWeight: 92.624,
    trendWeight: 93.054,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2856,
    trendFatPercent: 0.2896,
    trendFatMass: 26.947,
    trendLeanMass: 66.106,
  },
  {
    date: "2011-07-26",
    actualWeight: 92.805,
    trendWeight: 93.029,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2809,
    trendFatPercent: 0.2887,
    trendFatMass: 26.86,
    trendLeanMass: 66.169,
  },
  {
    date: "2011-07-27",
    actualWeight: 92.488,
    trendWeight: 92.975,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.293,
    trendFatPercent: 0.2891,
    trendFatMass: 26.883,
    trendLeanMass: 66.091,
  },
  {
    date: "2011-07-28",
    actualWeight: 92.352,
    trendWeight: 92.912,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.281,
    trendFatPercent: 0.2883,
    trendFatMass: 26.79,
    trendLeanMass: 66.122,
  },
  {
    date: "2011-07-29",
    actualWeight: 92.533,
    trendWeight: 92.875,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2835,
    trendFatPercent: 0.2878,
    trendFatMass: 26.734,
    trendLeanMass: 66.14,
  },
  {
    date: "2011-07-30",
    actualWeight: 92.488,
    trendWeight: 92.835,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2903,
    trendFatPercent: 0.2881,
    trendFatMass: 26.746,
    trendLeanMass: 66.09,
  },
  {
    date: "2011-07-31",
    actualWeight: 92.548,
    trendWeight: 92.807,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2918,
    trendFatPercent: 0.2885,
    trendFatMass: 26.772,
    trendLeanMass: 66.035,
  },
  {
    date: "2011-08-01",
    actualWeight: 92.608,
    trendWeight: 92.787,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2934,
    trendFatPercent: 0.2889,
    trendFatMass: 26.812,
    trendLeanMass: 65.975,
  },
  {
    date: "2011-08-02",
    actualWeight: 92.669,
    trendWeight: 92.775,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2949,
    trendFatPercent: 0.2895,
    trendFatMass: 26.863,
    trendLeanMass: 65.912,
  },
  {
    date: "2011-08-03",
    actualWeight: 92.442,
    trendWeight: 92.742,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2734,
    trendFatPercent: 0.2879,
    trendFatMass: 26.704,
    trendLeanMass: 66.037,
  },
  {
    date: "2011-08-04",
    actualWeight: 92.578,
    trendWeight: 92.726,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2868,
    trendFatPercent: 0.2878,
    trendFatMass: 26.689,
    trendLeanMass: 66.036,
  },
  {
    date: "2011-08-05",
    actualWeight: 92.488,
    trendWeight: 92.702,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2799,
    trendFatPercent: 0.287,
    trendFatMass: 26.609,
    trendLeanMass: 66.093,
  },
  {
    date: "2011-08-06",
    actualWeight: 92.896,
    trendWeight: 92.721,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2852,
    trendFatPercent: 0.2868,
    trendFatMass: 26.597,
    trendLeanMass: 66.124,
  },
  {
    date: "2011-08-07",
    actualWeight: 92.941,
    trendWeight: 92.743,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2917,
    trendFatPercent: 0.2873,
    trendFatMass: 26.649,
    trendLeanMass: 66.094,
  },
  {
    date: "2011-08-08",
    actualWeight: 92.352,
    trendWeight: 92.704,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2865,
    trendFatPercent: 0.2872,
    trendFatMass: 26.63,
    trendLeanMass: 66.074,
  },
  {
    date: "2011-08-09",
    actualWeight: 92.624,
    trendWeight: 92.696,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.289,
    trendFatPercent: 0.2874,
    trendFatMass: 26.644,
    trendLeanMass: 66.052,
  },
  {
    date: "2011-08-10",
    actualWeight: 92.896,
    trendWeight: 92.716,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2969,
    trendFatPercent: 0.2884,
    trendFatMass: 26.737,
    trendLeanMass: 65.979,
  },
  {
    date: "2011-08-11",
    actualWeight: 92.85,
    trendWeight: 92.729,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2901,
    trendFatPercent: 0.2885,
    trendFatMass: 26.757,
    trendLeanMass: 65.972,
  },
  {
    date: "2011-08-12",
    actualWeight: 92.125,
    trendWeight: 92.669,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2881,
    trendFatPercent: 0.2885,
    trendFatMass: 26.736,
    trendLeanMass: 65.933,
  },
  {
    date: "2011-08-13",
    actualWeight: 92.714,
    trendWeight: 92.674,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2962,
    trendFatPercent: 0.2893,
    trendFatMass: 26.808,
    trendLeanMass: 65.865,
  },
  {
    date: "2011-08-14",
    actualWeight: 93.1,
    trendWeight: 92.716,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2947,
    trendFatPercent: 0.2898,
    trendFatMass: 26.871,
    trendLeanMass: 65.845,
  },
  {
    date: "2011-08-15",
    actualWeight: 93.485,
    trendWeight: 92.793,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2932,
    trendFatPercent: 0.2902,
    trendFatMass: 26.925,
    trendLeanMass: 65.868,
  },
  {
    date: "2011-08-16",
    actualWeight: 93.319,
    trendWeight: 92.845,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2908,
    trendFatPercent: 0.2902,
    trendFatMass: 26.946,
    trendLeanMass: 65.899,
  },
  {
    date: "2011-08-17",
    actualWeight: 93.153,
    trendWeight: 92.876,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2884,
    trendFatPercent: 0.29,
    trendFatMass: 26.938,
    trendLeanMass: 65.938,
  },
  {
    date: "2011-08-18",
    actualWeight: 92.987,
    trendWeight: 92.887,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.286,
    trendFatPercent: 0.2896,
    trendFatMass: 26.904,
    trendLeanMass: 65.984,
  },
  {
    date: "2011-08-19",
    actualWeight: 93.44,
    trendWeight: 92.943,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2923,
    trendFatPercent: 0.2899,
    trendFatMass: 26.945,
    trendLeanMass: 65.998,
  },
  {
    date: "2011-08-20",
    actualWeight: 93.485,
    trendWeight: 92.997,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2913,
    trendFatPercent: 0.29,
    trendFatMass: 26.973,
    trendLeanMass: 66.024,
  },
  {
    date: "2011-08-21",
    actualWeight: 93.213,
    trendWeight: 93.019,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2906,
    trendFatPercent: 0.2901,
    trendFatMass: 26.985,
    trendLeanMass: 66.034,
  },
  {
    date: "2011-08-22",
    actualWeight: 92.941,
    trendWeight: 93.011,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.29,
    trendFatPercent: 0.2901,
    trendFatMass: 26.982,
    trendLeanMass: 66.029,
  },
  {
    date: "2011-08-23",
    actualWeight: 92.669,
    trendWeight: 92.977,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2893,
    trendFatPercent: 0.29,
    trendFatMass: 26.964,
    trendLeanMass: 66.012,
  },
  {
    date: "2011-08-24",
    actualWeight: 92.987,
    trendWeight: 92.977,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2886,
    trendFatPercent: 0.2899,
    trendFatMass: 26.952,
    trendLeanMass: 66.026,
  },
  {
    date: "2011-08-25",
    actualWeight: 93.077,
    trendWeight: 92.987,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.285,
    trendFatPercent: 0.2894,
    trendFatMass: 26.909,
    trendLeanMass: 66.079,
  },
  {
    date: "2011-08-26",
    actualWeight: 92.941,
    trendWeight: 92.983,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2831,
    trendFatPercent: 0.2888,
    trendFatMass: 26.849,
    trendLeanMass: 66.134,
  },
  {
    date: "2011-08-27",
    actualWeight: 92.805,
    trendWeight: 92.965,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2812,
    trendFatPercent: 0.288,
    trendFatMass: 26.774,
    trendLeanMass: 66.191,
  },
  {
    date: "2011-08-28",
    actualWeight: 92.85,
    trendWeight: 92.953,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2829,
    trendFatPercent: 0.2875,
    trendFatMass: 26.723,
    trendLeanMass: 66.23,
  },
  {
    date: "2011-08-29",
    actualWeight: 92.896,
    trendWeight: 92.948,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2845,
    trendFatPercent: 0.2872,
    trendFatMass: 26.694,
    trendLeanMass: 66.254,
  },
  {
    date: "2011-08-30",
    actualWeight: 92.941,
    trendWeight: 92.947,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2862,
    trendFatPercent: 0.2871,
    trendFatMass: 26.685,
    trendLeanMass: 66.263,
  },
  {
    date: "2011-08-31",
    actualWeight: 92.533,
    trendWeight: 92.906,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2836,
    trendFatPercent: 0.2867,
    trendFatMass: 26.64,
    trendLeanMass: 66.265,
  },
  {
    date: "2011-09-01",
    actualWeight: 92.624,
    trendWeight: 92.878,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2857,
    trendFatPercent: 0.2866,
    trendFatMass: 26.623,
    trendLeanMass: 66.255,
  },
  {
    date: "2011-09-02",
    actualWeight: 92.442,
    trendWeight: 92.834,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2911,
    trendFatPercent: 0.2871,
    trendFatMass: 26.651,
    trendLeanMass: 66.183,
  },
  {
    date: "2011-09-03",
    actualWeight: 92.488,
    trendWeight: 92.799,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2787,
    trendFatPercent: 0.2862,
    trendFatMass: 26.564,
    trendLeanMass: 66.236,
  },
  {
    date: "2011-09-04",
    actualWeight: 92.17,
    trendWeight: 92.737,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2772,
    trendFatPercent: 0.2853,
    trendFatMass: 26.462,
    trendLeanMass: 66.274,
  },
  {
    date: "2011-09-05",
    actualWeight: 92.306,
    trendWeight: 92.694,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.28,
    trendFatPercent: 0.2848,
    trendFatMass: 26.401,
    trendLeanMass: 66.293,
  },
  {
    date: "2011-09-06",
    actualWeight: 92.442,
    trendWeight: 92.668,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2827,
    trendFatPercent: 0.2846,
    trendFatMass: 26.374,
    trendLeanMass: 66.294,
  },
  {
    date: "2011-09-07",
    actualWeight: 92.079,
    trendWeight: 92.609,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2748,
    trendFatPercent: 0.2836,
    trendFatMass: 26.267,
    trendLeanMass: 66.342,
  },
  {
    date: "2011-09-08",
    actualWeight: 91.853,
    trendWeight: 92.534,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2767,
    trendFatPercent: 0.2829,
    trendFatMass: 26.182,
    trendLeanMass: 66.352,
  },
  {
    date: "2011-09-09",
    actualWeight: 92.17,
    trendWeight: 92.497,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2876,
    trendFatPercent: 0.2834,
    trendFatMass: 26.214,
    trendLeanMass: 66.283,
  },
  {
    date: "2011-09-10",
    actualWeight: 91.898,
    trendWeight: 92.437,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2859,
    trendFatPercent: 0.2836,
    trendFatMass: 26.22,
    trendLeanMass: 66.217,
  },
  {
    date: "2011-09-11",
    actualWeight: 91.943,
    trendWeight: 92.388,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2729,
    trendFatPercent: 0.2826,
    trendFatMass: 26.107,
    trendLeanMass: 66.281,
  },
  {
    date: "2011-09-12",
    actualWeight: 91.716,
    trendWeight: 92.321,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2731,
    trendFatPercent: 0.2816,
    trendFatMass: 26.001,
    trendLeanMass: 66.319,
  },
  {
    date: "2011-09-13",
    actualWeight: 91.807,
    trendWeight: 92.269,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.279,
    trendFatPercent: 0.2814,
    trendFatMass: 25.963,
    trendLeanMass: 66.307,
  },
  {
    date: "2011-09-14",
    actualWeight: 91.792,
    trendWeight: 92.222,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2773,
    trendFatPercent: 0.281,
    trendFatMass: 25.912,
    trendLeanMass: 66.31,
  },
  {
    date: "2011-09-15",
    actualWeight: 91.777,
    trendWeight: 92.177,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2757,
    trendFatPercent: 0.2804,
    trendFatMass: 25.851,
    trendLeanMass: 66.326,
  },
  {
    date: "2011-09-16",
    actualWeight: 91.762,
    trendWeight: 92.136,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.274,
    trendFatPercent: 0.2798,
    trendFatMass: 25.78,
    trendLeanMass: 66.356,
  },
  {
    date: "2011-09-17",
    actualWeight: 91.535,
    trendWeight: 92.076,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2806,
    trendFatPercent: 0.2799,
    trendFatMass: 25.771,
    trendLeanMass: 66.305,
  },
  {
    date: "2011-09-18",
    actualWeight: 91.297,
    trendWeight: 91.998,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2779,
    trendFatPercent: 0.2797,
    trendFatMass: 25.731,
    trendLeanMass: 66.267,
  },
  {
    date: "2011-09-19",
    actualWeight: 91.059,
    trendWeight: 91.904,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2751,
    trendFatPercent: 0.2792,
    trendFatMass: 25.663,
    trendLeanMass: 66.241,
  },
  {
    date: "2011-09-20",
    actualWeight: 90.821,
    trendWeight: 91.795,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2724,
    trendFatPercent: 0.2785,
    trendFatMass: 25.57,
    trendLeanMass: 66.225,
  },
  {
    date: "2011-09-21",
    actualWeight: 90.583,
    trendWeight: 91.674,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2696,
    trendFatPercent: 0.2776,
    trendFatMass: 25.455,
    trendLeanMass: 66.219,
  },
  {
    date: "2011-09-22",
    actualWeight: 91.399,
    trendWeight: 91.647,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2832,
    trendFatPercent: 0.2782,
    trendFatMass: 25.498,
    trendLeanMass: 66.148,
  },
  {
    date: "2011-09-23",
    actualWeight: 90.809,
    trendWeight: 91.563,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2647,
    trendFatPercent: 0.2768,
    trendFatMass: 25.352,
    trendLeanMass: 66.211,
  },
  {
    date: "2011-09-24",
    actualWeight: 91.218,
    trendWeight: 91.528,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2809,
    trendFatPercent: 0.2772,
    trendFatMass: 25.379,
    trendLeanMass: 66.149,
  },
  {
    date: "2011-09-25",
    actualWeight: 91.444,
    trendWeight: 91.52,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.281,
    trendFatPercent: 0.2776,
    trendFatMass: 25.411,
    trendLeanMass: 66.109,
  },
  {
    date: "2011-09-26",
    actualWeight: 90.673,
    trendWeight: 91.435,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2832,
    trendFatPercent: 0.2782,
    trendFatMass: 25.438,
    trendLeanMass: 65.998,
  },
  {
    date: "2011-09-27",
    actualWeight: 91.036,
    trendWeight: 91.395,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2647,
    trendFatPercent: 0.2768,
    trendFatMass: 25.304,
    trendLeanMass: 66.092,
  },
  {
    date: "2011-09-28",
    actualWeight: 90.9,
    trendWeight: 91.346,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2792,
    trendFatPercent: 0.2771,
    trendFatMass: 25.311,
    trendLeanMass: 66.035,
  },
  {
    date: "2011-09-29",
    actualWeight: 90.492,
    trendWeight: 91.261,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.276,
    trendFatPercent: 0.277,
    trendFatMass: 25.278,
    trendLeanMass: 65.983,
  },
  {
    date: "2011-09-30",
    actualWeight: 91.081,
    trendWeight: 91.242,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2609,
    trendFatPercent: 0.2754,
    trendFatMass: 25.126,
    trendLeanMass: 66.116,
  },
  {
    date: "2011-10-01",
    actualWeight: 90.673,
    trendWeight: 91.186,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2734,
    trendFatPercent: 0.2752,
    trendFatMass: 25.093,
    trendLeanMass: 66.093,
  },
  {
    date: "2011-10-02",
    actualWeight: 90.084,
    trendWeight: 91.076,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2539,
    trendFatPercent: 0.273,
    trendFatMass: 24.871,
    trendLeanMass: 66.205,
  },
  {
    date: "2011-10-03",
    actualWeight: 90.31,
    trendWeight: 90.999,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2614,
    trendFatPercent: 0.2719,
    trendFatMass: 24.744,
    trendLeanMass: 66.255,
  },
  {
    date: "2011-10-04",
    actualWeight: 89.585,
    trendWeight: 90.857,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2567,
    trendFatPercent: 0.2704,
    trendFatMass: 24.569,
    trendLeanMass: 66.288,
  },
  {
    date: "2011-10-05",
    actualWeight: 89.766,
    trendWeight: 90.748,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2714,
    trendFatPercent: 0.2705,
    trendFatMass: 24.549,
    trendLeanMass: 66.2,
  },
  {
    date: "2011-10-06",
    actualWeight: 89.494,
    trendWeight: 90.623,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2561,
    trendFatPercent: 0.269,
    trendFatMass: 24.386,
    trendLeanMass: 66.237,
  },
  {
    date: "2011-10-07",
    actualWeight: 89.811,
    trendWeight: 90.542,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2664,
    trendFatPercent: 0.2688,
    trendFatMass: 24.34,
    trendLeanMass: 66.202,
  },
  {
    date: "2011-10-08",
    actualWeight: 89.993,
    trendWeight: 90.487,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2555,
    trendFatPercent: 0.2674,
    trendFatMass: 24.205,
    trendLeanMass: 66.282,
  },
  {
    date: "2011-10-09",
    actualWeight: 89.978,
    trendWeight: 90.436,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2603,
    trendFatPercent: 0.2667,
    trendFatMass: 24.127,
    trendLeanMass: 66.309,
  },
  {
    date: "2011-10-10",
    actualWeight: 89.962,
    trendWeight: 90.388,
    weightIsInterpolated: true,
    fatIsInterpolated: true,
    actualFatPercent: 0.2652,
    trendFatPercent: 0.2666,
    trendFatMass: 24.1,
    trendLeanMass: 66.289,
  },
  {
    date: "2011-10-11",
    actualWeight: 89.947,
    trendWeight: 90.344,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.27,
    trendFatPercent: 0.2669,
    trendFatMass: 24.118,
    trendLeanMass: 66.226,
  },
  {
    date: "2011-10-12",
    actualWeight: 89.585,
    trendWeight: 90.269,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2571,
    trendFatPercent: 0.2659,
    trendFatMass: 24.01,
    trendLeanMass: 66.259,
  },
  {
    date: "2011-10-13",
    actualWeight: 89.449,
    trendWeight: 90.187,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2635,
    trendFatPercent: 0.2657,
    trendFatMass: 23.966,
    trendLeanMass: 66.221,
  },
  {
    date: "2011-10-14",
    actualWeight: 89.857,
    trendWeight: 90.153,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2645,
    trendFatPercent: 0.2656,
    trendFatMass: 23.946,
    trendLeanMass: 66.208,
  },
  {
    date: "2011-10-15",
    actualWeight: 89.176,
    trendWeight: 90.056,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2552,
    trendFatPercent: 0.2645,
    trendFatMass: 23.827,
    trendLeanMass: 66.229,
  },
  {
    date: "2011-10-16",
    actualWeight: 89.086,
    trendWeight: 89.959,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2621,
    trendFatPercent: 0.2643,
    trendFatMass: 23.779,
    trendLeanMass: 66.179,
  },
  {
    date: "2011-10-17",
    actualWeight: 89.086,
    trendWeight: 89.871,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2462,
    trendFatPercent: 0.2625,
    trendFatMass: 23.595,
    trendLeanMass: 66.277,
  },
  {
    date: "2011-10-18",
    actualWeight: 88.95,
    trendWeight: 89.779,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2619,
    trendFatPercent: 0.2624,
    trendFatMass: 23.565,
    trendLeanMass: 66.215,
  },
  {
    date: "2011-10-19",
    actualWeight: 88.632,
    trendWeight: 89.664,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2491,
    trendFatPercent: 0.2611,
    trendFatMass: 23.416,
    trendLeanMass: 66.248,
  },
  {
    date: "2011-10-20",
    actualWeight: 88.995,
    trendWeight: 89.598,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2475,
    trendFatPercent: 0.2597,
    trendFatMass: 23.277,
    trendLeanMass: 66.32,
  },
  {
    date: "2011-10-21",
    actualWeight: 88.768,
    trendWeight: 89.515,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2565,
    trendFatPercent: 0.2594,
    trendFatMass: 23.226,
    trendLeanMass: 66.288,
  },
  {
    date: "2011-10-22",
    actualWeight: 89.222,
    trendWeight: 89.485,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2583,
    trendFatPercent: 0.2593,
    trendFatMass: 23.208,
    trendLeanMass: 66.277,
  },
  {
    date: "2011-10-23",
    actualWeight: 88.768,
    trendWeight: 89.414,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2519,
    trendFatPercent: 0.2586,
    trendFatMass: 23.124,
    trendLeanMass: 66.29,
  },
  {
    date: "2011-10-24",
    actualWeight: 88.723,
    trendWeight: 89.345,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2528,
    trendFatPercent: 0.258,
    trendFatMass: 23.054,
    trendLeanMass: 66.29,
  },
  {
    date: "2011-10-25",
    actualWeight: 88.95,
    trendWeight: 89.305,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2587,
    trendFatPercent: 0.2581,
    trendFatMass: 23.05,
    trendLeanMass: 66.255,
  },
  {
    date: "2011-10-26",
    actualWeight: 89.222,
    trendWeight: 89.297,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2546,
    trendFatPercent: 0.2577,
    trendFatMass: 23.016,
    trendLeanMass: 66.28,
  },
  {
    date: "2011-10-27",
    actualWeight: 89.176,
    trendWeight: 89.285,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2476,
    trendFatPercent: 0.2567,
    trendFatMass: 22.923,
    trendLeanMass: 66.362,
  },
  {
    date: "2011-10-28",
    actualWeight: 89.494,
    trendWeight: 89.306,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2582,
    trendFatPercent: 0.2568,
    trendFatMass: 22.941,
    trendLeanMass: 66.364,
  },
  {
    date: "2011-10-29",
    actualWeight: 88.496,
    trendWeight: 89.224,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2488,
    trendFatPercent: 0.256,
    trendFatMass: 22.849,
    trendLeanMass: 66.376,
  },
  {
    date: "2011-10-30",
    actualWeight: 88.723,
    trendWeight: 89.175,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2566,
    trendFatPercent: 0.2561,
    trendFatMass: 22.841,
    trendLeanMass: 66.334,
  },
  {
    date: "2011-10-31",
    actualWeight: 88.451,
    trendWeight: 89.102,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2497,
    trendFatPercent: 0.2555,
    trendFatMass: 22.765,
    trendLeanMass: 66.337,
  },
  {
    date: "2011-11-01",
    actualWeight: 88.95,
    trendWeight: 89.087,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2508,
    trendFatPercent: 0.255,
    trendFatMass: 22.72,
    trendLeanMass: 66.367,
  },
  {
    date: "2011-11-02",
    actualWeight: 88.904,
    trendWeight: 89.068,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2567,
    trendFatPercent: 0.2552,
    trendFatMass: 22.73,
    trendLeanMass: 66.339,
  },
  {
    date: "2011-11-03",
    actualWeight: 88.587,
    trendWeight: 89.02,
    weightIsInterpolated: false,
    fatIsInterpolated: false,
    actualFatPercent: 0.2542,
    trendFatPercent: 0.2551,
    trendFatMass: 22.709,
    trendLeanMass: 66.312,
  },
];

// Demo provider status (all good)
export const demoProviderStatus: Record<string, ProviderSyncStatus> = {
  fitbit: {
    success: true,
  },
};

// Function to get demo data with current dates
export function getDemoData(): MeasurementsResponse {
  const today = new Date();

  // Calculate the offset between the original last date and today
  const originalLastDate = new Date("2011-11-03"); // Last date from original demo data
  const daysDiff = Math.floor((today.getTime() - originalLastDate.getTime()) / (1000 * 60 * 60 * 24));

  // Adjust computed measurement dates by adding the offset
  const computedMeasurementsWithAdjustedDates = preComputedDemoMeasurements.map((measurement) => {
    const originalDate = new Date(measurement.date);
    const adjustedDate = new Date(originalDate);
    adjustedDate.setDate(adjustedDate.getDate() + daysDiff);

    return {
      ...measurement,
      date: adjustedDate.toISOString().split("T")[0],
    };
  });

  return {
    computedMeasurements: computedMeasurementsWithAdjustedDates,
    providerStatus: demoProviderStatus,
    isMe: false,
  };
}

// Function to get demo profile with adjusted dates
export function getDemoProfile(): ProfileData {
  // Calculate the offset to adjust the goal start date
  const today = new Date();
  const originalLastDate = new Date("2011-11-03"); // Last date from original demo data
  const daysDiff = Math.floor((today.getTime() - originalLastDate.getTime()) / (1000 * 60 * 60 * 24));

  // Adjust the original start date from the data
  const originalStartDate = new Date("2011-03-23"); // First date from original demo data
  const adjustedStartDate = new Date(originalStartDate);
  adjustedStartDate.setDate(adjustedStartDate.getDate() + daysDiff);

  return {
    ...demoProfile,
    goalStart: adjustedStartDate.toISOString().split("T")[0],
  };
}
